<template>
  <vs-row vs-justify="center" id="business-box">
    <vs-col type="flex-nowrap" vs-lg="12" vs-xs="12" style="overflow-y: unset;">
      <vs-input
        :danger="errors.responsible"
        :danger-text="
          $t('Errors.InvalidPolite', {
            field: $t('Company.Name'),
          })
        "
        :label="$t('Reseller.Add.Name')"
        placeholder="12n"
        v-model="reseller.responsible"
        class="w-100 mb-2"
      />

      <vs-input
        :label="$t('Reseller.Add.Email')"
        placeholder="12n"
        v-model="reseller.email"
        class="w-100 mb-2"
      />

      <vs-col vs-w="6">
        <vs-input
          :danger="errors.phone"
          :danger-text="
            $t('Errors.InvalidPolite', {
              field: $t('Company.PhoneNumber'),
            })
          "
          :label="$t('Reseller.Add.Phone')"
          :placeholder="$t('Company.PhoneNumber')"
          v-model="reseller.phone"
          class="w-100 mt-2"
        />
      </vs-col>

      <vs-col vs-w="6">
        <vs-input
          maxlength="11"
          :label="$t('Reseller.Add.SocialReason')"
          placeholder="Liberrex"
          v-model="reseller.social_reason"
          class="w-100 mb-2 mt-2"
        />
      </vs-col>

      <div class="btn-alignment float-right mt-4">
        <vs-button color="primary" @click="validateFields">{{
          $t("Reseller.Add.AddButton")
        }}</vs-button>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  helpersService,
  businessService,
  industryServices,
  harifService,
  resellerService,
} from "../../_services";
import { gmapApi } from "vue2-google-maps";
import WorkingDay from "../../components/settings/WorkingDay";
import router from "../../_helpers/router";
export default {
  name: "Business",
  data: () => ({
    verified: false,
    sumError: 0,
    title: "Business",
    activeTab: 0,
    reseller: {},
    photo: "",
    currentLocation: { lat: 0, lng: 0 },
    markers: [],
    errors: {
      responsible: false,
      address: false,
      postal_code: false,
      city: false,
      phone: false,
      industry: false,
      subIndustry: false,
    },
    countries: [],
    cities: [],
    industries: [],
    organizations: [],
    harif_gateways: [],
    subindustries: [],
    steps: [
      {
        target: ".vs-card--content", // We're using document.querySelector() under the hood
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#information-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#working-days-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#location-tab", // We're using document.querySelector() under the hood
        params: {
          placement: "top-start", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
    ],
    languages: [],
    business_translations: {
      ar: "",
      fr: "",
      en: "",
      de: "",
      es: "",
      ru: "",
      pt: "",
    },
    permissions: {
      booking_allowed: false,
      booking_require_approval: false,
      booking_select_date: false,
      booking_select_slot: false,
      booking_select_department: false,
      booking_allow_attachments: false,
      booking_require_attachments: false,
      queue_allowed: false,
      queue_require_approval: false,
      queue_only_booked: false,
      queue_require_payment: false,
      anonymous_feedback: false,
      feedback_view: false,
      allow_kiosks: false,
      allow_display: false,
    },
  }),
  methods: {
    ...mapActions("account", ["updateUserObject"]),
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    validateFields() {
      (this.errors.responsible = this.reseller.responsible ? false : true),
        (this.errors.phone = this.reseller.phone ? false : true);

      let { responsible, phone } = this.errors;
      console.log(this.errors);
      if (
        this.errors.responsible == false &&
        this.errors.phone == false
        //this.errors.industry == false
      ) {
        this.createReseller();
        console.log("famch errors");
      } else {
        console.log("fama errors");
      }
    },
    showLoading() {
      this.$vs.loading({
        container: "#business-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#business-box > .con-vs-loading");
    },
    createReseller() {
      // this.showLoading();
      // this.validateFields();
      this.showLoading();

      let reseller = new FormData();
      reseller.append("responsible", this.reseller.responsible);
      reseller.append("email", this.reseller.email);
      reseller.append("phone", this.reseller.phone);
      reseller.append("social_reason", this.reseller.social_reason);

      reseller.append("_method", "POST");

      resellerService
        .create(reseller)
        .then(
          function(data) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Company.EditBasic.ToastSuccess"),
              "success"
            );
          }.bind(this)
        )
        .catch(
          function() {
            this.notify(
              this.$t("Toasts.Error"),
              this.$t("Company.EditBasic.ToastFail"),
              "danger"
            );
          }.bind(this)
        )
        .finally(
          function() {
            this.hideLoading();
            router.go();
          }.bind(this)
        );
      // console.log(this.business.working_days);
    },
    updatePermission() {
      const self = this;
      this.showLoading();
      let permissions = new FormData();
      permissions.append("id", this.permissions.id);
      permissions.append("business_id", this.permissions.business_id);
      permissions.append("booking_allowed", this.permissions.booking_allowed);
      permissions.append(
        "booking_require_approval",
        this.permissions.booking_require_approval
      );
      permissions.append(
        "booking_select_date",
        this.permissions.booking_select_date
      );
      permissions.append(
        "booking_select_slot",
        this.permissions.booking_select_slot
      );
      permissions.append(
        "booking_select_department",
        this.permissions.booking_select_department
      );
      permissions.append(
        "booking_allow_attachments",
        this.permissions.booking_allow_attachments
      );
      permissions.append(
        "booking_require_attachments",
        this.permissions.booking_require_attachments
      );
      permissions.append("queue_allowed", this.permissions.queue_allowed);
      permissions.append(
        "queue_only_booked",
        this.permissions.queue_only_booked
      );
      permissions.append(
        "queue_require_approval",
        this.permissions.queue_require_approval
      );
      permissions.append(
        "queue_require_payment",
        this.permissions.queue_require_payment
      );
      permissions.append(
        "anonymous_feedback",
        this.permissions.anonymous_feedback
      );
      permissions.append("feedback_view", this.permissions.feedback_view);
      permissions.append("allow_kiosks", this.permissions.allow_kiosks);
      permissions.append("allow_display", this.permissions.allow_display);

      permissions.append("_method", "POST");

      businessService
        .updatePermissions(permissions)
        .then(function(data) {
          this.permissions = data.settings;
          self.notify(
            self.$t("Toasts.Successful"),
            self.$t("Company.EditBasic.ToastSuccess"),
            "success"
          );
          self.hideLoading();
        })
        .catch(function() {
          self.notify(
            self.$t("Toasts.Successful"),
            self.$t("Company.EditBasic.ToastSuccess"),
            "success"
          );
          self.hideLoading();
        });
    },
    updateCoordinates(location) {
      this.markers[0].position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    goToNextTab(currentStep) {
      this.$tours["SettingsBusiness"].nextStep();
      if (currentStep == 1) {
        this.activeTab = 1;
      } else if (currentStep == 2) {
        this.activeTab = 2;
      }
    },
    goToNextPage() {
      router.push({ path: "/settings/team?istour=on" });
    },
    getsubindustries() {
      let data2 = { industry_id: this.business.industry_id };
      industryServices.getsubindustries(data2).then(
        function(data) {
          if (this.business.industry != data2.industry_id) {
            this.business.subindustry = 0;
          }
          this.subindustries = data.subindustries;
        }.bind(this)
      );
    },
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      business_info: (state) => state.account.user.business,
      workingDays: (state) => state.account.user.working_days,
    }),
    google: gmapApi,
  },

  components: {
    WorkingDay,
  },
};
</script>
